// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2666":"b46394f95a969363","3997":"56bb4444ff56c7ab","4143":"d1ffcbb93dfe2d3a","7540":"e6a3d1cf66f0ddf4"}[chunkId] + ".css";
};